<template>
    <a-modal
        :visible="visible"
        :title="'Geri Sayım Ayarları - ' + widget.title"
        width="600px"
        :footer="null"
        @cancel="$emit('close')"
        class="countdown-settings-modal"
        :destroyOnClose="true"
    >
        <a-form :form="form" layout="vertical">
            <!-- Hedef Tarih -->
            <a-form-item :label="$t('table.targetDateAndTime')">
                <div class="date-time-inputs">
                    <a-date-picker
                        :value="$moment(previewSettings.targetDate)"
                        @change="(date) => handleDateChange(date)"
                        format="DD.MM.YYYY"
                        style="width: 200px"
                    />
                    <a-time-picker
                        :value="$moment(previewSettings.targetDate)"
                        @change="(time) => handleTimeChange(time)"
                        format="HH:mm"
                        style="width: 100px"
                    />
                </div>
            </a-form-item>

            <!-- Gösterilecek Birimler -->
            <a-form-item :label="$t('table.unitsToDisplay')">
                <div class="units-grid">
                    <a-checkbox v-model="previewSettings.showUnits.months">{{ $t('table.months') }}</a-checkbox>
                    <a-checkbox v-model="previewSettings.showUnits.weeks">{{ $t('table.weeks') }}</a-checkbox>
                    <a-checkbox v-model="previewSettings.showUnits.days">{{ $t('table.days') }}</a-checkbox>
                    <a-checkbox v-model="previewSettings.showUnits.hours">{{ $t('table.hours') }}</a-checkbox>
                    <a-checkbox v-model="previewSettings.showUnits.minutes">{{ $t('table.minutes') }}</a-checkbox>
                    <a-checkbox v-model="previewSettings.showUnits.seconds">{{ $t('table.seconds') }}</a-checkbox>
                </div>
            </a-form-item>

            <!-- Stil Ayarları -->
            <a-collapse>
                <a-collapse-panel :header="$t('table.styleSettings')" key="1">
                    <a-form-item :label="$t('table.backgroundColor')">
                        <a-input type="color" v-model="previewSettings.style.backgroundColor" />
                    </a-form-item>

                    <a-form-item :label="$t('table.textColor')">
                        <a-input type="color" v-model="previewSettings.style.textColor" />
                    </a-form-item>

                    <a-form-item :label="$t('table.numberSize')">
                        <a-slider v-model="previewSettings.style.fontSize" :min="16" :max="96" :step="4" />
                    </a-form-item>

                    <a-form-item :label="$t('table.labelSize')">
                        <a-slider v-model="previewSettings.style.labelFontSize" :min="12" :max="32" :step="2" />
                    </a-form-item>
                </a-collapse-panel>
            </a-collapse>

            <!-- Önizleme -->
            <a-form-item :label="$t('table.preview')" class="preview-section">
                <div
                    class="preview-container"
                    :style="{
                        backgroundColor: previewSettings.style.backgroundColor,
                        color: previewSettings.style.textColor,
                        padding: '24px',
                    }"
                >
                    <div class="countdown-preview">
                        <div
                            v-if="previewSettings.showUnits.months"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">5</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.months') }}
                            </div>
                        </div>
                        <div
                            v-if="previewSettings.showUnits.weeks"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">2</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.weeks') }}
                            </div>
                        </div>
                        <div
                            v-if="previewSettings.showUnits.days"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">15</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.days') }}
                            </div>
                        </div>
                        <div
                            v-if="previewSettings.showUnits.hours"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">23</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.hours') }}
                            </div>
                        </div>
                        <div
                            v-if="previewSettings.showUnits.minutes"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">45</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.minutes') }}
                            </div>
                        </div>
                        <div
                            v-if="previewSettings.showUnits.seconds"
                            class="countdown-unit"
                            :style="{ fontSize: previewSettings.style.fontSize + 'px' }"
                        >
                            <div class="value">30</div>
                            <div class="label" :style="{ fontSize: previewSettings.style.labelFontSize + 'px' }">
                                {{ $t('table.seconds') }}
                            </div>
                        </div>
                    </div>
                </div>
            </a-form-item>

            <!-- Kaydet/İptal Butonları -->
            <div class="form-actions">
                <a-button @click="$emit('close')">{{ $t('table.cancel') }}</a-button>
                <a-button type="primary" @click="handleSave" :loading="saving">{{ $t('table.save') }}</a-button>
            </div>
        </a-form>
    </a-modal>
</template>

<script>
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "CountdownSettingsModal",
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        widget: {
            type: Object,
            required: true,
        },
    },
    data() {
        const defaultSettings = {
            targetDate: this.$moment().add(1, "day").toDate(),
            showUnits: {
                months: false,
                weeks: false,
                days: false,
                hours: true,
                minutes: true,
                seconds: true,
            },
            style: {
                backgroundColor: "#ffffff",
                textColor: "#000000",
                fontSize: 48,
                labelFontSize: 16,
            },
        };

        // Widget'ın mevcut ayarlarını al veya varsayılan ayarları kullan
        const settings = this.widget.settings || {};
        
        // Ayarları birleştir, eksik alanları varsayılan değerlerle doldur
        const mergedSettings = {
            targetDate: settings.targetDate || defaultSettings.targetDate,
            showUnits: {
                ...defaultSettings.showUnits,
                ...(settings.showUnits || {}),
            },
            style: {
                ...defaultSettings.style,
                ...(settings.style || {}),
            },
        };

        return {
            form: this.$form.createForm(this),
            previewSettings: mergedSettings,
            saving: false,
        };
    },
    mounted() {
        // Eğer targetDate string olarak geldiyse Date objesine çevirelim
        if (typeof this.previewSettings.targetDate === "string") {
            this.previewSettings.targetDate = this.$moment(this.previewSettings.targetDate).toDate();
        }
    },
    methods: {
        handleDateChange(date) {
            if (!date) return;
            const currentTime = this.$moment(this.previewSettings.targetDate);
            const newDate = this.$moment(date)
                .hour(currentTime.hour())
                .minute(currentTime.minute())
                .second(currentTime.second());
            this.previewSettings.targetDate = newDate.toDate();
        },
        handleTimeChange(time) {
            if (!time) return;
            const currentDate = this.$moment(this.previewSettings.targetDate);
            const newTime = this.$moment(time);
            const newDate = currentDate.hour(newTime.hour()).minute(newTime.minute()).second(newTime.second());
            this.previewSettings.targetDate = newDate.toDate();
        },
        async handleSave() {
            try {
                this.saving = true;
                await this.$emit("save", this.previewSettings);
            } catch (error) {
                console.error("Ayarlar kaydedilirken hata:", error);
                this.$message.error("Ayarlar kaydedilirken bir hata oluştu");
            } finally {
                this.saving = false;
            }
        },
    },
});
</script>

<style lang="scss">
.countdown-settings-modal {
    .date-time-inputs {
        display: flex;
        gap: 16px;
    }

    .units-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
    }

    .preview-section {
        margin-top: 24px;
    }

    .preview-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: hidden;

        .countdown-preview {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 24px;
            padding: 24px;

            .countdown-unit {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;

                .value {
                    font-weight: 600;
                }

                .label {
                    color: inherit;
                    opacity: 0.65;
                }
            }
        }
    }

    .form-actions {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
}
</style>
